import { FormattedMessage } from 'react-intl'
import { components, OptionProps } from 'react-select'

import { Option } from '@models/option'
import { PatientOptionModel } from '@models/patient'

import { FormatDate } from '@/components/FormatDate'

const ReactSelectPatientOption = <Opt = Option,>(props: OptionProps<Opt>) => {
  const data = props.data as unknown as Option<PatientOptionModel>
  const patient = data.data

  return (
    <components.Option {...props}>
      <div className="d-flex flex-column">
        <div className="fw-medium d-flex align-items-center">{patient?.full_name}</div>

        {patient && (
          <table className="mt-1">
            <colgroup>
              <col width={130} />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <td>
                  <FormattedMessage id="patient.id" />
                </td>
                <td>: {patient.patient_id}</td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage id="patient.mobile_phone_number" />
                </td>
                <td>: {patient.mobile_phone_number || '-'}</td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage id="patient.nric" />
                </td>
                <td>: {patient.nric_number || '-'}</td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage id="patient.passport_number" />
                </td>
                <td>: {patient.passport_number || '-'}</td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage id="vocabulary.birth_date" />
                </td>
                <td>
                  : <FormatDate date={patient.birth_date} />
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </components.Option>
  )
}

export { ReactSelectPatientOption }
